module.exports = __webpack_public_path__ + "img/jumpilla-2.f9a0138d.jpg";